import { createRoot } from 'react-dom/client'
import React, {Suspense, StrictMode } from 'react';
import App from './App'

createRoot(document.getElementById('root')).render(<App />)
